import * as React from "react";

interface IFormErrorListProps {
    message: string;
    show: boolean;
    errors: string[];
}

export class FormErrorList extends React.Component<IFormErrorListProps>
{
    render() {
        if (!this.props.show) {
            return null;
        }

        return (<div className="ui error message visible">
                <div className="header">{this.props.message}</div>
                <ul>
                    {this.props.errors.map((e) =>
                        <li key={e}>
                            {e}
                        </li>)}
                </ul>            
        </div>);
    }
}